export const Utils = {
    url: (url) => url,
    print: () => window.print()
}

export const getParam = (pageable) => {
    let pageStr = "";
    let sort = "sort=";
    let size = '&size=';
    let page = '&page=';
    const desc = ',desc';
    if (pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }
    if (pageable.size) {
        size += pageable.size;
    }
    page += pageable.page;
    pageStr = sort + size + page;
    return pageStr;
}

export const getDateAsString = (time, specificDate) => {
    let now = !specificDate ? new Date() : new Date(specificDate);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    if (time) {
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        // 예: "2024-9-19 12:00:00"
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    // 예: "2024-9-19"
    return `${year}-${month}-${day}`;
}

